import styled from "styled-components";

const LogoImage = styled.img`
  //max-width: 200px;
  //height: auto;

  @media (max-width: 768px) {
    display: block;
    margin: 0 auto;
    padding-top: 4rem;
  }
`;

const AboutMuseum = () => {
  return (
    <div>
      <LogoImage
        src="/images/g/muzej_01_2.jpg"
        alt="citajte o - muzej savremene umetnosti"
      />
      <div>
        <br></br>
        <br></br>
        1948. - Raspisan prvi (uži) konkurs za zgradu Moderne galerije na levoj
        obali reke Save. Prvu nagradu na konkursu su dobili arhitekti Edvard
        Ravnikar i Veljko Kauzlarić. Druga nagrada pripala je arhitekti Branku
        Petričiću. Projekat nije realizovan.
        <br></br>
        <br></br>
        1951-1954. - Predsednici Saveta za nauku i kulturu FNR Jugoslavije i
        Saveta za prosvetu, nauku i kulturu NR Srbije (predsednica Mitra
        Mitrović) započinju prve konsultacije o formiranju Moderne galerije. -
        Predloženo je više postojećih zgrada u Beogradu za buduću Modernu
        galeriju. Nijedan predlog nije usvojen. - Izvršno veće NR Srbije
        saglasilo se sa odlukom Saveta za nauku i kulturu o početku
        organizovanja rada na osnivanju Moderne galerije. - Stručna komisija
        Saveta za prosvetu i kulturu NR Srbije je vršila otkupe dela u nameri da
        ih ustupi budućoj Modernoj galeriji. U tom periodu fond dela broji 200
        eksponata. Dela su privremeno ustupljena na revers raznim kulturnim
        ustanovama u Beogradu i unutrašnjosti. Ovakva saradnja uspostavljena je
        i sa Sekretarijatom za prosvetu i kulturu NO grada Beograda.
        <br></br>
        <br></br>
        1954. - Savet za prosvetu, nauku i kulturu NR Srbije (odsek za kulturu)
        sprovodi pismenu anketu umetnika i stručnih organizacija o potrebi
        osnivanja Moderne galerije. Neki od učesnika bili su Svetozar Radojčić
        šef katedre za istoriju umetnosti, Sreten Stojanović rektor Akademije
        likovnih umetnosti, Nada Andrejević Kun predsednica Srpskog muzejskog
        društva, Oto Bihalji Merin književnik, Branko Šotra rektor Akademije
        primenjenih umetnosti, Udruženje likovnih umetnika Srbije kao i slikari
        Petar Lubarda, Milo Milunović, Đorđe Andrejević Kun, Predrag
        Milosavljević, Milan Konjović, Marko Čelebonović, Miloje Nikolajević.
        Svi anketirani podržali su ideju o osnivanju Moderne galerije.
        <br></br>
        <br></br>
        1955. -Savet za prosvetu i kulturu NR Srbije doneo je rešenje da se
        imenuje Odbor Moderne galerije sastavljen od stručnjaka i javnih
        ličnosti, koji bi radio na definisanju koncepcije buduće galerije. Odbor
        su činili: Stanka Veselinov predsednica, Miodrag B. Protić sekretar,
        Veljko Petrović, Oto Bihalji Merin, Milo Milunović koji je zbog obaveza
        odustao, Đorđe Andrejević Kun, Svetozar Radojčić, Predrag Milosavljević,
        Stevan Bodnarov, Dobrica Ćosić, Vlado Mađarić i Aleksa Čelebonović.
        Odboru je postavljeno nekoliko zadataka kao što su: izrada plana o
        postavci Galerije; proučavanje organizacija sličnih ustanova u svetu i
        izrada plana za organizaciju Moderne galerije; predlog adekvatne zgrade
        (posojeće koja bi se adaptirala ili skiciranje nove koju bi trebalo
        sagraditi); Otkup najznačajnijih dela sa tekućih izložbi sredstvima
        Saveta NR Srbije. - Posle dvogodišnjeg rada Odbor je izneo koncept za
        osnivanje Moderne galerije. Konstatovano je da u zemlji ne postoji
        galerija jugoslovenske umetnosti, zbog čega bi Moderna galerija trebala
        da prikaže celokupan razvoj umetnosti sa jugoslovenskog umetničkog
        prostora od 1900. do danas. Pored navedenog Galerija treba da ima
        funkciju naučne i prosvetne ustanove, čuvara umetničkog blaga, kao i
        političku funkciju koja bi se odnosila na međurepubličku i međunarodnu
        saradnju. Namera je bila da buduća Galerija postane centar
        jugoslovenskog i evropskog umetničkog života. - Savet za prosvetu i
        kulturu NR Srbije i Savet za prosvetu i kulturu NO Grada Beograda
        prihvatio je koncepciju Odbora Galerije. - Odbor je odlučio da započne
        da prikuplja i grupiše dela za buduću postavku savremene jugoslovenske
        umetnosti u Modernoj galeriji. O pitanjima slovenačke i hrvatske
        umetnosti konsultovani su dr. France Stele profesor Univerziteta u
        Ljubljani, dr. Grga Gamulin i dr. Ljubo Babić profesori Univerziteta u
        Zagrebu.
        <br></br>
        <br></br>
        1958. - 17. juna Rešenjem Saveta za kulturu Narodnog odbora grada
        Beograda doneta je odluka o osnivanju Moderne galerije. 1959. - Galerija
        započinje pripremni rad u privremenim prostorijama u potkrovlju na
        Obilićevom vencu br. 5 . Miodrag B. Protić imenovan je za upravnika. -
        Na osnovu načelne odluke Izvršnog veća NR Srbije, Savet za kulturu
        osnovao je Odbor za izradu programa izgradnje Moderne galerije. Članovi
        odbora su bili: Milorad Panić Surep predsednik, arhitekti Branko
        Petričić, Oliver Minić, Stanko Mandić, slikari Momčilo Stevanović i Peđa
        Milosavljević, vajar Risto Stijović i Miodrag B. Protić upravnik
        Galerije. - Krajem godine Odbor raspisuje konkurs za izradu idejnog
        rešenja zgrade i imenuje žiri u sastavu: Miodrag Panić Surep, Branko
        Petričić, Oliver Minić, Stanko Mandić, Dušan Milenković, Đorđe Krekić,
        Predrag Milosavljević, Momčilo Stefanović, Miodrag B. Protić.
        <br></br>
        <br></br>
        1960. - Rezultati konkursa su objavljeni 25. januara 1960 godine. Na
        konkursu za izradu idejnog rešenja zgrade prijavilo se 18 radova. Prvu
        nagradu je dobio projekat arhitekata Ivana Antića i Ivanke Raspopović.
        Druga nagada pripala je arhitektima Risti Šekerinskom i studentu
        arhitekture Petru Pavliću. Treća nagrada nije dodeljena. Žiri je odlučio
        da otkupi nekoliko projekata. Prvi otkup pripao je arhitektima Slobodanu
        Mihajloviću i Draganu Raspopoviću, drugi arhitektima Prvoslavu
        Jankoviću, Aleksandru Stijepanoviću i Božidaru Jankoviću i treći
        arhitekti Aleksandru Ljahinickom. Van konkursa otkupljen je i rad
        ljubljanskih arhitekata Janeza Lajovica, Stanka Kristla, Majde Dobrovec,
        Marijane Vidmar. - Radovi na izgradnji zgrade trajali su od 1960. do
        1965. godine. Pripreme za izgradnju bile su usporene menjanjem prvobitne
        lokacije koja je bila ustanovljena na levoj novobeogradskoj obali ušća
        Save u Dunav, na rubu magistrale, preko puta zgrade Centralnog komiteta.
        Nova lokacija Galerije pomerena je ka samom ušću Save u Dunav, odmičući
        se od magistrale i zgrade CK. - Investitor izgradnje zgrade bilo je
        Izvršno veće SR Srbije; Urbanističku razradu je ustanovio Urbanistički
        zavod Beograda (dipl. arh. Milutin Glavički); Na organizaciji izvođenja
        radova i izradi projekta učestvovala je Direkcija za izgradnju Novog
        Beograda; Investiciono-tehničku dokumentaciju izradio je Projektni biro
        građevinskog preduzeća "Rad"; Odgovorni projejktanti za građevinske i
        građevinsko-zanatske radove bili su dipl.arh. Ivan Antić i dipl. arh.
        Ivanka Raspopović, a za statički proračun dipl.ing. Edmund Balgač.
        Enterijer su projektovali dipl. arh. Ivan Antić, dipl. arh. Ivanka
        Raspopović i dipl. arh Toma Đorđević; Izvođač radova bilo je Građevinsko
        preduzeće "7. juli". - Formiraju se muzejske zbirke, nabavlja se
        dokumentacija, studira postavka. Programiraju se dugoročni zadaci
        Muzeja, postepeno se izgrađuje njegova organizacija. Izvršena je
        klasifikacija dela po vrednosti. - Narodni odbor grada Beograda osnovao
        je pri Modernoj galeriji u Beogradu Oktobarski salon kao stalnu
        manifestaciju koja će svakog 20. oktobra u čast godišnjice oslobađanja
        Beograda organizovati reprezentativnu izložbu dostignuća likovne
        umetnosti u Narodnoj Republici Srbiji. - Moderna galerija je primila od
        Narodnog odbora grada Beograda novu izložbenu prostoriju u Parijskoj
        ulici br. 14 pod nazivom Salon Moderne galerije.
        <br></br>
        <br></br>
        1961. - 11. maja otvoren je Salon Moderne galerije, danas Salon Muzeja
        savremene umetnosti, sa izložbom Nedeljka Gvozdenovića. Salon je imao
        stalni program i određenu koncepciju.
        <br></br>
        <br></br>
        1962. - Završeni su grubi građevinski radovi i zgrada Moderne galerije
        stavljena je pod krov. - Usvojen je Pravilnik Salona Modene galerije. -
        Otkupljena su kapitalna dela među kojima 7 ulja Nadežde Petrović, Pijana
        Lađa Save Šumanovića, Pejzaži Riharda Jakopiča, dela Jovana Bijelića,
        Ignjata Joba i drugih jugoslovenskih umetnika.
        <br></br>
        <br></br>
        1963- 1964. - U saradnji sa arhitektima razrađeno je pitanje opremanja
        enterijera, depoa i radionica. - U Zagrebu je otvorena izložba Savremena
        srpska umetnost – posleratni period. Izložba je bila prilika da se
        prikaže deo buduće postavke Moderne galerije.
        <br></br>
        <br></br>
        1965. - Usvajanjem rešenja Saveta Moderne galerije od 22. marta 1965. uz
        odobrenje Skuštine grada, naziv Moderne galerije promenjen je u Muzej
        savremene umetnosti. - Muzej savremene umetnosti je otvoren 20. oktobara
        u 10 h. Svečani govor su održali Miodrag B. Protić upravnik i Branko
        Pešić predsednik Skupštine grada Beograda. Između ostalih ceremoniji su
        prisustvovali i Aleksandar Ranković, Jovan Veselinov, Blaža Jovanović,
        Mijalko Todorović, Dušan Petrović, Koča Popović, Dragi Stamenković,
        Milojko Drulović, Vojin Lukić, i dr. - Dodeljena je Oktobarska nagrada
        za najbolja dostignuća iz oblasti arhitekture Ivanu Antiću i Ivanki
        Raspopović za realizaciju zgrade Muzeja savremene umetnosti. (Žiri u
        sastavu: arhitekte Stanko Mandić, Ivo Kurtović, Bogdan Bogdanović,
        Milorad Macura i Josip Svoboda). - Na dan otvaranja Muzej broji oko 3
        000 dela (slika, tapiserija, skulptura, obijekata, crteža, grafika). -
        Prva prikazana izložba u prostoru Muzeja (oktobar/decembar) je
        Jugoslovenska grafika XX veka. - Prva inostrana izložba u Muzeju
        savremene umetnosti bila je Vizije Danteovog "Pakla" – crteži 1965,
        sovijetskog umetika Ernsta Neizvestnog. - Štampana je monografija o
        Muzeju savremene umetnosti, knjigu uredio Miodrag B. Protić u saradnji
        sa stručnim kolegijumom.
        <br></br>
        <br></br>
        Izvori: 1. Istorijat rada na osnivanju Moderne galerije, Savet za
        prosvetu i kulturu NR Srbije, br. 12874 od 19.11.1954. 2. Miodrag B.
        Protić, Istorijat Muzeja savremene umetnosti u: Vodič MSUB, Muzej
        savremene umetnosti, Beograd, 1965, str.18-19. 3. Referat o radu Odbora
        Moderne galerije i zaključci po pitanju osnivanja Moderne galerije,
        Dokumentacija MSUB 4. Izveštaji o radu Moderne galerije 1960-1965.
        godine, MSUB, Odeljenje za umetničku dokumentaciju MSUB 5. Deset godina
        Muzeja savremene umetnosti u Beogradu 1965-1975, Muzej savremene
        umetnosti, Beograd, 1975. 6. Oliver Minić, Moderna galerija u Beogradu,
        Arhitektura i urbanizam br. 16, God. III, 1962. 7. Ljiljana Blagojević,
        „Političke kulture“ u: Novi Beograd : Osporeni modernizam, Zavod za
        udžbenike, Arhitektonski fakultet, Zavod za zaštitu spomenika, Beograd,
        2007, str. 232-240 8. Milan Popadić, Arhitektura Muzeja savremene
        umetnosti u Beogradu, Nasleđe br. 10, Beograd, 2009, Str. 159-178.
      </div>
      <div style={{ height: "50px" }} />
    </div>
  );
};

export default AboutMuseum;
